<!-- 规则弹窗 -->
<template>
  <div class="rule-popup">
    <van-overlay :show="show" @click="close" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <p class="text1">活动规则</p>
        <p class="text2">{{ ruleStr }}</p>
        <div>
          <p style="line-height: 1.5">下滑动查看更多↓</p>
          <img
            class="btn"
            @click="close"
            :src="
              require(`@/assets/imgs/putianPostalNationalDayLottery/pic3.png`)
            "
            alt=""
          />
        </div>
      </div>
      <!-- <img
        class="close"
        @click="close"
        :src="
          require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/close.png`)
        "
        alt=""
      /> -->
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  components: {},
  data() {
    return {
      show: false,
      ruleStr: `一、活动时间
2024年9月29日至2024年10月7日
二、活动对象
邮储银行莆田市分行信用卡客户
三、活动内容
活动期间，莆田市辖区邮储银行信用卡客户，通过邮储银行企业微信福利群或宣传海报活动路径扫描二维码立即参与，单客户每日有机会参与1次抽奖，（有机会抽中奖品：1元、5元微信立减金、10元饿了么/美团app微信立减金、加油满200元-15元微信立减金），每日11200个名额。共设100800个名额，奖品数量有限，先到先得。
四、活动细则
1.活动期间，客户需微信开启定位，本活动仅限所属为莆田市邮储银行信用卡客户专享。
2.满足同一微信账户、同一身份证号、同一手机号、同一银行卡号、同一手机设备，均视为同一客户。
3.使用范围：客户抽中微信立减金领取成功立即生效，请在7日内核销有效，过期作废，不再补发。其中1元、5元微信立减金在中国境内商户使用微信绑定邮储银行信用卡支付即可抵扣，少数特定商户（包括但不限于：CoCo奶茶、优衣库、星巴克、肯德基、同程艺龙、热风、太平鸟、孩子王、航联保险、华为商城、Miss Sixty、Ochirly、Apple商城、Five Plus、零钱通、理财通等）无法使用立减金，社交支付（如转账、红包、个人收款码支付等）及合单支付（微信支付订单号为44开头的交易）无法使用立减金。10元美团/饿了么微信立减金仅限app下单选择微信绑定邮储银行信用卡支付。中石化满200元立减15元微信立减金仅限【易捷加油】微信小程序-【钱包充值】-选择微信支付绑定邮储银行信用卡抵扣。
4.退款规则：使用立减金的微信支付订单，如发生全额退款，且立减金在有效期内，申请当日将自动退还（退款金额到账，优惠券即会退还），请注意查看微信卡包；如发生部分退款，用户支付金额将按比例原路退还，立减金将不退还给用户；如立减金已过期，则不退还该立减金。
5.微信立减金仅限中奖领取客户本人使用，不支持转发给他人，立减金不找零。
6.本次活动主办方:中国邮政储蓄银行股份有限公司莆田市分行，活动由易点生活提供支持，客服热线：400-662-7299。
7.在法律法规允许范围内，如出现不可抗力的情形，邮储银行莆田市分行保留调整、暂停、终止活动的权利，并经邮储银行莆田市分行微信公众号公告或短信通知后生效。
`
    }
  },
  methods: {
    close() {
      this.setShow(false)
      this.$emit('ruleClose')
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.rule-popup {
  position: relative;
  text-align: center;

  .wrapper {
    margin: 15% 20px 20px 20px;
    border: 5px solid #abd0fa;
    background: #ddecff;
    border-radius: 10px;
    text-align: center;
    text-align: center;
    overflow: auto;
    .text1 {
      padding: 30px 0 10px 0;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }
    .text2 {
      padding: 20px 20px;
      font-size: 12px;
      // color: #ffffff;
      line-height: 1.5;
      text-align: left;
      white-space: pre-wrap;
      text-align: justify;
      max-height: 53vh;
      overflow: auto;
    }
    .btn {
      margin: 10px 0;
      width: 100px;
    }
  }
  .close {
    width: 35px;
  }
}
</style>
